/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Tracker_IdleInputs */

const he_extension_tracker_idle = /** @type {(inputs: Extension_Tracker_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עקוב עם PriceDrop`)
};

const en_extension_tracker_idle = /** @type {(inputs: Extension_Tracker_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track on PriceDrop`)
};

/**
* | output |
* | --- |
* | "Track on PriceDrop" |
*
* @param {Extension_Tracker_IdleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const extension_tracker_idle = /** @type {((inputs?: Extension_Tracker_IdleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Tracker_IdleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_tracker_idle(inputs)
	return en_extension_tracker_idle(inputs)
});